(function () {
  // Block Hextom Ultimate Sales Boost on non-published themes so the draft
  // preview can be evaluated without it. Live theme (role === 'main') is
  // untouched — Hextom keeps running there until manually uninstalled.
  const themeRole = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
  if (themeRole && themeRole !== 'main') {
    const HEXTOM_HOST = 'cdn.hextom.com';
    const srcDesc =
      Object.getOwnPropertyDescriptor(HTMLScriptElement.prototype, 'src') ||
      Object.getOwnPropertyDescriptor(HTMLElement.prototype, 'src');
    if (srcDesc && srcDesc.configurable) {
      Object.defineProperty(HTMLScriptElement.prototype, 'src', {
        configurable: true,
        enumerable: true,
        get() { return srcDesc.get.call(this); },
        set(value) {
          if (typeof value === 'string' && value.indexOf(HEXTOM_HOST) !== -1) {
            return;
          }
          srcDesc.set.call(this, value);
        },
      });
    }
    new MutationObserver((records) => {
      records.forEach((r) => {
        r.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.tagName === 'SCRIPT') {
            const s = node.getAttribute('src') || '';
            if (s.indexOf(HEXTOM_HOST) !== -1) node.remove();
          }
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  const STOCK_CLASS = 'custom-stock-badge';
  const TRUST_CLASS = 'custom-trust-row';

  const ICONS = {
    bolt:
      '<svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">' +
      '<path d="M9.5 1 3 9h4l-.5 6L13 7H9l.5-6Z"/></svg>',
    shield:
      '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M8 1.5 2.5 3.5v4.2c0 3.2 2.3 5.6 5.5 6.8 3.2-1.2 5.5-3.6 5.5-6.8V3.5L8 1.5Z"/>' +
      '<path d="m5.7 8 1.7 1.7L10.6 6.4"/></svg>',
    truck:
      '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M1.5 4h8v7h-8z"/>' +
      '<path d="M9.5 6.5h3l2 2.5v2h-5z"/>' +
      '<circle cx="4.5" cy="12" r="1.3" fill="currentColor" stroke="none"/>' +
      '<circle cx="11.5" cy="12" r="1.3" fill="currentColor" stroke="none"/></svg>',
  };

  const CATEGORY_BADGES = {
    'category:software': [
      { icon: 'bolt', text: 'Instant digital delivery' },
      { icon: 'shield', text: 'Genuine software' },
    ],
    'category:hardware': [
      { icon: 'truck', text: 'Delivered within 1-3 working days' },
    ],
  };

  function readInventoryCount(productInfo) {
    const sectionId = productInfo.dataset.section;
    if (!sectionId) return null;
    const el = document.getElementById('Inventory-' + sectionId);
    if (!el) return null;
    const match = (el.textContent || '').match(/(\d[\d,]*)/);
    if (!match) return null;
    const n = parseInt(match[1].replace(/,/g, ''), 10);
    return Number.isNaN(n) ? null : n;
  }

  function describeStockFromDOM(productInfo) {
    const submit = productInfo.querySelector('.product-form__submit');
    if (submit && submit.hasAttribute('disabled')) {
      return { state: 'out', text: 'Out of stock' };
    }
    const count = readInventoryCount(productInfo);
    const suffix = count != null ? ' · ' + count + ' left' : '';
    return { state: 'in', text: 'In stock' + suffix };
  }

  function buildStockBadge() {
    const badge = document.createElement('div');
    badge.className = STOCK_CLASS;
    badge.setAttribute('role', 'status');
    badge.setAttribute('aria-live', 'polite');
    badge.innerHTML =
      '<span class="' + STOCK_CLASS + '__dot" aria-hidden="true"></span>' +
      '<span class="' + STOCK_CLASS + '__text"></span>';
    return badge;
  }

  function mountStockBadge(productInfo) {
    const quantityContainer = productInfo.querySelector('.product-form__quantity');
    if (!quantityContainer) return;

    const badge = buildStockBadge();
    quantityContainer.appendChild(badge);

    function update() {
      const info = describeStockFromDOM(productInfo);
      badge.dataset.state = info.state;
      badge.querySelector('.' + STOCK_CLASS + '__text').textContent = info.text;
      badge.hidden = !info.text;
    }

    update();

    const sectionId = productInfo.dataset.section;
    const inventoryEl = sectionId ? document.getElementById('Inventory-' + sectionId) : null;
    const submit = productInfo.querySelector('.product-form__submit');
    const obs = new MutationObserver(update);
    if (inventoryEl) {
      obs.observe(inventoryEl, { childList: true, subtree: true, characterData: true });
    }
    if (submit) {
      obs.observe(submit, { attributes: true, attributeFilter: ['disabled'] });
    }
  }

  function pickCategoryBadges(tags) {
    if (!Array.isArray(tags)) return null;
    const normalized = tags.map((t) => String(t).toLowerCase().trim());
    const keys = Object.keys(CATEGORY_BADGES);
    for (let i = 0; i < keys.length; i++) {
      if (normalized.indexOf(keys[i]) !== -1) return CATEGORY_BADGES[keys[i]];
    }
    return null;
  }

  function mountCategoryBadges(productInfo, tags) {
    if (productInfo.querySelector('[data-custom-trust]')) return;
    const badges = pickCategoryBadges(tags);
    if (!badges || !badges.length) return;

    const anchor = productInfo.querySelector('product-form .product-form__buttons');
    if (!anchor) return;

    const row = document.createElement('div');
    row.className = TRUST_CLASS;
    row.setAttribute('data-custom-trust', 'true');

    badges.forEach((b) => {
      const item = document.createElement('div');
      item.className = TRUST_CLASS + '__item';
      const icon = ICONS[b.icon] || '';
      item.innerHTML = icon + '<span>' + b.text + '</span>';
      row.appendChild(item);
    });

    anchor.insertAdjacentElement('afterend', row);
  }

  function readTagsFromDOM(productInfo) {
    const tagScript = productInfo.querySelector('script[data-product-tags]');
    if (!tagScript) return null;
    try {
      const parsed = JSON.parse(tagScript.textContent || '[]');
      return Array.isArray(parsed) ? parsed : null;
    } catch (_) {
      return null;
    }
  }

  // Cap the product media (image + thumbnails) column to the natural
  // content height of the info column on desktop so they end at the
  // same baseline. Measures .product__info-container (the inner section)
  // not the wrapper — the wrapper is a grid item that gets stretched to
  // row height by the grid layout, so its offsetHeight already equals
  // the media height and would make the cap a no-op.
  function mountMediaHeightMatch(productInfo) {
    const DESKTOP_BREAKPOINT = 990;
    const mediaWrapper = productInfo.querySelector('.product__media-wrapper');
    const infoContainer = productInfo.querySelector('.product__info-container');
    if (!mediaWrapper || !infoContainer) return;

    const sync = () => {
      if (window.innerWidth < DESKTOP_BREAKPOINT) {
        mediaWrapper.style.maxHeight = '';
        mediaWrapper.style.height = '';
        return;
      }
      // Floor of 500px = Spotlight's --constrained-min-height. Without
      // this, very short info columns would cap the wrapper below the
      // image's intrinsic min-height and the image would clip.
      const target = Math.max(500, infoContainer.offsetHeight);
      mediaWrapper.style.maxHeight = target + 'px';
      mediaWrapper.style.height = '';
    };

    sync();

    if ('ResizeObserver' in window) {
      new ResizeObserver(sync).observe(infoContainer);
    }
    window.addEventListener('resize', sync);
  }

  // Fade main product images in once they're decoded so the user never
  // sees a partial / popping image when navigating from the catalog.
  // CSS starts the img at opacity: 0; we set data-loaded="true" after
  // decode() resolves to trigger the 0.35s opacity transition.
  function mountSmoothImageLoad(productInfo) {
    const imgs = productInfo.querySelectorAll('.product__media-item img');
    imgs.forEach((img) => {
      const markLoaded = () => {
        img.dataset.loaded = 'true';
      };
      if (img.complete && img.naturalWidth > 0) {
        markLoaded();
        return;
      }
      if (typeof img.decode === 'function') {
        img.decode().then(markLoaded).catch(markLoaded);
      } else {
        img.addEventListener('load', markLoaded, { once: true });
        img.addEventListener('error', markLoaded, { once: true });
      }
    });
  }

  // Pre-warm the non-active gallery images so swapping to them (thumbnail hover /
  // click) is instant instead of triggering a fresh network fetch. Spotlight marks
  // every slide after the first loading="lazy"; we fetch their resolved sources off
  // the critical path (idle / post-load) into the browser cache, leaving the initial
  // paint and LCP untouched. When the lazy <img> later loads, it hits the cache.
  function mountGalleryPreload(productInfo) {
    const imgs = Array.from(productInfo.querySelectorAll('.product__media-item img'));
    if (imgs.length < 2) return;
    const warm = () => {
      imgs.forEach((img) => {
        if (img.dataset.warmed === 'true') return;
        const src = img.currentSrc || img.src;
        if (!src) return;
        img.dataset.warmed = 'true';
        const pre = new Image();
        if (img.sizes) pre.sizes = img.sizes;
        if (img.srcset) pre.srcset = img.srcset;
        pre.src = src; // browser dedupes against the real lazy load
      });
    };
    if ('requestIdleCallback' in window) {
      requestIdleCallback(warm, { timeout: 2000 });
    } else {
      setTimeout(warm, 600);
    }
  }

  // (Removed) hover-to-swap thumbnails. The main image now changes on CLICK only
  // (Spotlight's default) — hover just zooms the thumbnail slightly via CSS. The old
  // hover-swap re-triggered Spotlight's setActiveMedia (and its horizontal slide) on
  // every cursor pass over the thumbnails, which read as the gallery "sliding".

  // Up/down arrow buttons to page the vertical thumbnail column, instead of a scrollbar.
  // Only added when the column actually overflows (more than ~5 thumbnails). The buttons
  // scroll the column smoothly and hide themselves at the top/bottom extremes.
  function mountThumbnailScroll(productInfo) {
    const col = productInfo.querySelector('.product__media-vertical > .thumbnail-slider');
    if (!col || col.dataset.thumbNav === 'true') return;

    const build = () => {
      if (col.dataset.thumbNav === 'true') return;
      // Decide by COUNT, not overflow: the cap only exists after we wrap, so an overflow check
      // here is always false (chicken-and-egg). 5 thumbnails fit; more need the scroll + arrows.
      const items = col.querySelectorAll('.thumbnail-list__item').length;
      if (items <= 5) return;
      col.dataset.thumbNav = 'true';

      const svg = (d) =>
        `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="${d}"/></svg>`;
      const mk = (dir) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'thumb-scroll thumb-scroll--' + dir;
        b.setAttribute('aria-label', dir === 'up' ? 'Previous thumbnails' : 'More thumbnails');
        b.innerHTML = svg(dir === 'up' ? 'm6 15 6-6 6 6' : 'm6 9 6 6 6-6');
        return b;
      };
      const up = mk('up');
      const down = mk('down');

      // Wrap the strip + buttons in a flex column: buttons sit ABOVE and BELOW the thumbnails
      // (in-flow, not overlaying), and the whole unit centres vertically against the main image.
      const nav = document.createElement('div');
      nav.className = 'thumb-nav';
      col.parentElement.insertBefore(nav, col);
      nav.append(up, col, down);

      const step = () => Math.max(col.clientHeight * 0.85, 120);
      up.addEventListener('click', () => col.scrollBy({ top: -step(), behavior: 'smooth' }));
      down.addEventListener('click', () => col.scrollBy({ top: step(), behavior: 'smooth' }));

      const update = () => {
        up.classList.toggle('is-disabled', col.scrollTop <= 2);
        down.classList.toggle('is-disabled', col.scrollTop + col.clientHeight >= col.scrollHeight - 2);
      };
      col.addEventListener('scroll', update, { passive: true });
      update();
    };
    // wait for layout so scrollHeight is real
    requestAnimationFrame(() => requestAnimationFrame(build));
  }

  function initProductInfo(productInfo) {
    if (productInfo.dataset.customInit === 'true') return;
    productInfo.dataset.customInit = 'true';

    mountStockBadge(productInfo);
    mountThumbnailScroll(productInfo);
    // mountMediaHeightMatch disabled — capping the wrapper to the info
    // column's height was making Spotlight's intrinsic .media height
    // (driven by padding-top) overflow the wrapper, which then clipped
    // the image instead of scaling it down. Accept a small column-height
    // mismatch over visibly clipped images.
    mountSmoothImageLoad(productInfo);
    mountGalleryPreload(productInfo);

    const tagsSync = readTagsFromDOM(productInfo);
    if (tagsSync) {
      mountCategoryBadges(productInfo, tagsSync);
      return;
    }

    const productUrl = productInfo.dataset.url;
    if (!productUrl) return;
    fetch(productUrl + '.js', { headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (data && Array.isArray(data.tags)) mountCategoryBadges(productInfo, data.tags);
      })
      .catch(() => {});
  }

  // Preload related-products immediately on page load instead of waiting
  // for Spotlight's IntersectionObserver (which only fires when the
  // section approaches viewport, causing a visible AJAX swap mid-scroll).
  // We fire the same fetch as global.js's ProductRecommendations and
  // inject the result early — by the time the user scrolls down it's
  // already there. Spotlight's own observer may still fire later and
  // re-fetch; that's a harmless no-op since the content is identical.
  function preloadRelatedProducts() {
    document.querySelectorAll('product-recommendations').forEach((el) => {
      const baseUrl = el.dataset.url;
      const productId = el.dataset.productId;
      const sectionId = el.dataset.sectionId;
      if (!baseUrl || !productId || !sectionId) return;
      if (el.querySelector('.grid__item')) return;

      fetch(baseUrl + '&product_id=' + productId + '&section_id=' + sectionId)
        .then((r) => r.text())
        .then((text) => {
          const wrapper = document.createElement('div');
          wrapper.innerHTML = text;
          const recs = wrapper.querySelector('product-recommendations');
          if (recs && recs.innerHTML.trim().length) {
            el.innerHTML = recs.innerHTML;
          }
          if (wrapper.querySelector('.grid__item')) {
            el.classList.add('product-recommendations--loaded');
          }
        })
        .catch(() => {});
    });
  }

  // Collection intro clamp: the banner description is clamped to 2 lines via .dl-clamp
  // (custom.css §27). If the text actually overflows the clamp, append a Read more toggle;
  // short intros get no toggle and never look truncated.
  function mountCollectionDescClamp() {
    document.querySelectorAll('.collection-hero__description.dl-clamp').forEach((el) => {
      if (el.scrollHeight <= el.clientHeight + 1) return;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'dl-desc-more';
      btn.textContent = 'Read more';
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', () => {
        const open = el.classList.toggle('is-open');
        btn.textContent = open ? 'Read less' : 'Read more';
        btn.setAttribute('aria-expanded', String(open));
      });
      el.insertAdjacentElement('afterend', btn);
    });
  }

  /* Re-tick a countdown the moment the tab becomes visible again: browsers
     throttle (or pause) setInterval in background tabs, so without this the
     clock sits stale for up to a second or more after a tab switch, and a
     bfcache restore (back/forward) can resume with a very old face. */
  function keepTimerFresh(tick) {
    setInterval(tick, 1000);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) tick();
    });
    window.addEventListener('pageshow', tick);
  }

  /* --- Deal countdown (PDP) ------------------------------------------------
     snippets/dl-deal-timer.liquid renders the pill with data-deal-deadline
     (unix seconds). Tick every second; "2d 05:12:44" over 24h, "05:12:44"
     under. Hide the pill at zero so an expired deal never shows even if the
     page HTML was cached. The tick re-queries the DOM each time: the theme's
     section re-renders (variant/quantity updates) can replace the pill node,
     and a closure over the original element would leave a frozen clock. */
  function mountDealTimer() {
    if (!document.querySelector('[data-deal-deadline]')) return;
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      const el = document.querySelector('[data-deal-deadline]');
      if (!el) return;
      const clock = el.querySelector('[data-deal-clock]');
      const deadline = parseInt(el.dataset.dealDeadline, 10) * 1000;
      if (!clock || !deadline) return;
      const left = deadline - Date.now();
      if (left <= 0) {
        el.hidden = true;
        return;
      }
      const s = Math.floor(left / 1000);
      const days = Math.floor(s / 86400);
      const hms = `${pad(Math.floor((s % 86400) / 3600))}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)}`;
      clock.textContent = days > 0 ? `${days}d ${hms}` : hms;
      el.hidden = false;
    };
    tick();
    keepTimerFresh(tick);
  }

  /* --- Cart reservation countdown (cart page) ------------------------------
     "Items reserved for 00:14:32" in the Order Summary. A 15-minute window
     whose deadline lives in localStorage so it survives navigation/reload:
     - first visit with items in the cart starts the clock
     - adding items (count went up) restarts it at 15:00
     - reaching zero hides the pill and it stays hidden (no sneaky reset on
       reload) until something new is added
     - emptying the cart clears the stored state
     The tick re-queries the DOM each second because the theme replaces the
     .js-contents wrapper (timer included) on AJAX quantity updates; that also
     re-hides the element, so the tick keeps un-hiding it while time remains. */
  function mountCartTimer() {
    if (!document.querySelector('.dl-cart-timer')) return;
    const KEY = 'dl-cart-reserve';
    const WINDOW_MS = 15 * 60 * 1000;
    const pad = (n) => String(n).padStart(2, '0');

    // In-memory fallback so the countdown still runs (per-page) when
    // localStorage is blocked (private mode, partitioned iframes).
    let memState = null;
    const load = () => {
      try {
        return JSON.parse(localStorage.getItem(KEY)) || memState;
      } catch (e) {
        return memState;
      }
    };
    const save = (state) => {
      memState = state;
      try {
        localStorage.setItem(KEY, JSON.stringify(state));
      } catch (e) {
        /* storage unavailable: memState carries the page session */
      }
    };

    // Multi-tab safety: a cart tab left open while the cart changes elsewhere
    // has a STALE data-cart-count. If it may lower the stored count, the fresh
    // tab sees "items added" every tick and resets the clock to 15:00 forever
    // (both tabs freeze). So: stored count only ever goes UP, and after the
    // first tick a tab only restarts the window when IT observes an increase.
    let firstTick = true;
    let lastDomCount = null;

    const tick = () => {
      const el = document.querySelector('.dl-cart-timer');
      if (!el) return; // cart emptied and section re-rendered without it
      const count = parseInt(el.dataset.cartCount, 10) || 0;
      if (!count) {
        try {
          localStorage.removeItem(KEY);
        } catch (e) {
          /* ignore */
        }
        memState = null;
        el.hidden = true;
        return;
      }
      let state = load();
      const grew = firstTick
        ? !state || count > state.count // fresh page: items were added since last visit
        : lastDomCount !== null && count > lastDomCount; // same tab: watched it grow
      firstTick = false;
      lastDomCount = count;
      if (!state || grew) {
        state = { deadline: Date.now() + WINDOW_MS, count: count };
      }
      if (count > state.count) state.count = count;
      save(state);

      const left = state.deadline - Date.now();
      if (left <= 0) {
        // Expired: safe to sync the stored count DOWN to the current cart, so a
        // later add is seen as growth and restarts the window. (While the clock
        // is live the count stays monotonic — that's the multi-tab-war guard.)
        if (count < state.count) {
          state.count = count;
          save(state);
        }
        el.hidden = true;
        return;
      }
      const s = Math.floor(left / 1000);
      const clock = el.querySelector('[data-cart-clock]');
      if (clock) {
        clock.textContent = `${pad(Math.floor(s / 3600))}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)}`;
      }
      el.hidden = false;
    };
    tick();
    keepTimerFresh(tick);
  }

  function boot() {
    document.querySelectorAll('product-info').forEach(initProductInfo);
    preloadRelatedProducts();
    mountCollectionDescClamp();
    mountDealTimer();
    mountCartTimer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
